import React from "react";
import "./newlaunch.scss";
import Cardrumah from "../../component/cardrumah/cardrumah";
import prdk from "../produk/produk.json";
import {
  AT52,
  AT61,
  AT62,
  AT72,
  AT82,
} from "../../asset/produk/alexandrite/alexandrite";

const imageMap = { AT52, AT61, AT62, AT72, AT82 };

const newlaunch = () => {
  return (
    <div className="newlaunch">
      <div className="container-newlaunch">
        <div className="header-newlaunch">
          <div className="judul-newlaunch">NEW LAUNCHING</div>
          <div className="subjudul-newlaunch">CLUSTER ALEXANDRITE</div>
        </div>
        <div className="cardhome-container">
          {prdk.newlaunching.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default newlaunch;
